import html from './main.html';
import lang from './main.lang.json';


export default {
    template: html,

    i18n: {
        messages: lang
    },
};

